import Logo from 'v3/components/Logo';
import LogoFinancing from 'v3/assets/svg/logo-financing.svg';
import { percent } from 'v3/utils/formatNumber';
import currency from 'currency.js';

import * as S from './styles';

type Values = {
  fees?: number;
  costOfCredit?: number;
  totalCost?: number;
  downPayment?: number;
  totalSavings?: number;
};

export type ComparisonTableTypes = {
  sc: Values;
  traditional: Values;
};

const ComparisonTable = ({ sc, traditional }: ComparisonTableTypes) => {
  return (
    <S.Wrapper>
      <S.DesktopOnly>
        <S.Table>
          <S.THead>
            <tr>
              <td></td>
              <td>Fees *</td>
              <td>Cost of Credit</td>
              <td>Total Cost</td>
              <td>Down Payment</td>
              <td>Total Saving</td>
            </tr>
          </S.THead>
          <tbody>
            <S.SCRow>
              <S.LogoCell>
                <Logo />
              </S.LogoCell>
              <td>{sc?.fees ? `${percent(sc.fees)} EAPR` : '-'}</td>
              <td>
                {sc?.costOfCredit ? currency(sc.costOfCredit).format() : '-'}
              </td>
              <td>{sc?.totalCost ? currency(sc.totalCost).format() : '-'}</td>
              <td>
                {sc?.downPayment ? currency(sc.downPayment).format() : '-'}
              </td>
              <S.SCSavings aria-label="Savings Club - total savings">
                {sc?.totalSavings ? currency(sc.totalSavings).format() : '$0'}
              </S.SCSavings>
            </S.SCRow>
            <S.TraditionalRow>
              <S.LogoCell>
                <img src={LogoFinancing} alt="Traditional Financing Logo" />
              </S.LogoCell>
              <td>
                {traditional?.fees ? `${percent(traditional.fees)} APR` : '-'}
              </td>
              <td>
                {traditional?.costOfCredit
                  ? currency(traditional.costOfCredit).format()
                  : '-'}
              </td>
              <td>
                {traditional?.totalCost
                  ? currency(traditional.totalCost).format()
                  : '-'}
              </td>
              <td>
                {traditional?.downPayment
                  ? currency(traditional.downPayment).format()
                  : '-'}
              </td>
              <S.TraditionalSavings aria-label="Traditional Financing - total savings">
                {traditional?.totalSavings
                  ? currency(traditional.totalSavings).format()
                  : '$0'}
              </S.TraditionalSavings>
            </S.TraditionalRow>
          </tbody>
        </S.Table>
      </S.DesktopOnly>

      <S.MobileOnly>
        <S.MobileTable>
          <thead>
            <tr>
              <td></td>
              <td>
                <Logo />
              </td>
              <td>
                <img src={LogoFinancing} alt="Traditional Financing Logo" />
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <S.TitleCell>Fees *</S.TitleCell>
              <S.ValueCell variant="sc">
                {sc?.fees ? `${percent(sc.fees)} EAPR` : <span>-</span>}
              </S.ValueCell>
              <S.ValueCell variant="traditional">
                {traditional?.fees ? (
                  `${percent(traditional.fees)} APR`
                ) : (
                  <span>-</span>
                )}
              </S.ValueCell>
            </tr>
            <tr>
              <S.TitleCell>Cost of Credit</S.TitleCell>
              <S.ValueCell variant="sc">
                {sc?.costOfCredit ? (
                  currency(sc.costOfCredit).format()
                ) : (
                  <span>-</span>
                )}
              </S.ValueCell>
              <S.ValueCell variant="traditional">
                {traditional?.costOfCredit ? (
                  currency(traditional.costOfCredit).format()
                ) : (
                  <span>-</span>
                )}
              </S.ValueCell>
            </tr>
            <tr>
              <S.TitleCell>Total Cost</S.TitleCell>
              <S.ValueCell variant="sc">
                {sc?.totalCost ? (
                  currency(sc.totalCost).format()
                ) : (
                  <span>-</span>
                )}
              </S.ValueCell>
              <S.ValueCell variant="traditional">
                {traditional?.totalCost ? (
                  currency(traditional.totalCost).format()
                ) : (
                  <span>-</span>
                )}
              </S.ValueCell>
            </tr>
            <tr>
              <S.TitleCell>Down Payment</S.TitleCell>
              <S.ValueCell variant="sc">
                {sc?.downPayment ? (
                  currency(sc.downPayment).format()
                ) : (
                  <span>-</span>
                )}
              </S.ValueCell>
              <S.ValueCell variant="traditional">
                {traditional?.downPayment ? (
                  currency(traditional.downPayment).format()
                ) : (
                  <span>-</span>
                )}
              </S.ValueCell>
            </tr>
            <tr>
              <S.TitleCell>Total Saving</S.TitleCell>
              <S.SCSavings aria-label="Savings Club - total savings">
                {sc?.totalSavings ? currency(sc.totalSavings).format() : '$0'}
              </S.SCSavings>
              <S.TraditionalSavings aria-label="Traditional Financing - total savings">
                {traditional?.totalSavings
                  ? currency(traditional.totalSavings).format()
                  : '$0'}
              </S.TraditionalSavings>
            </tr>
          </tbody>
        </S.MobileTable>
      </S.MobileOnly>
    </S.Wrapper>
  );
};

export default ComparisonTable;
